import { lib } from 'crypto-js';

export const generateSeed = (): string => {
    // CryptoJS uses words (4 bytes) instead of bytes,
    // so we divide the number of desired bytes by 4
    const randomWords = lib.WordArray.random(32 / 4);
    return randomWords.toString(); // This will output a hex string by default
};